import React from "react";
import { createBaseBlock } from "./BaseBlock";
import { Layout, Space, Typography } from "antd";
import { CardControls } from "../components/CardControls";
import { tagBlock } from "./TagBlock";

interface FooterData {
  hideFavorite?: boolean;
  hideCopyLink?: boolean;
  tags?: string[];
  processedRecords?: number;
  totalRecords?: number;
}

// Footer Block Recipe - minimal since this is a UI-only block
const footerRecipe = {
  id: "footer-block",
  name: "Footer Block",
  globalKey: [],
  prefix: "",
  format: {
    type: "json",
    fields: [],
    constraints: [],
  },
  validationRules: [],
};

// Footer Block Parser. Nothing to parse here.
function footerParser(data: any) {
  return {
    data: null,
  };
}

// Footer Block Variants
const footerVariants = [
  {
    id: "default",
    name: "Default",
    description: "Standard footer with all controls",
    defaultSettings: {
      hideFavorite: false,
      hideCopyLink: false,
      showStats: true,
      showTags: true,
    },
  },
  {
    id: "minimal",
    name: "Minimal",
    description: "Minimal footer with only essential controls",
    defaultSettings: {
      hideFavorite: true,
      hideCopyLink: false,
      showStats: false,
      showTags: false,
    },
  },
  {
    id: "controls-only",
    name: "Controls Only",
    description: "Footer with only control buttons",
    defaultSettings: {
      hideFavorite: false,
      hideCopyLink: false,
      showStats: false,
      showTags: false,
    },
  },
];

// Footer Block Renderer
function FooterBlockRenderer(props: any) {
  const { variant, link, tags, data } = props;

  //need to get the settings basedd on the variant
  const variantSettings = footerVariants.find(
    (v) => v.id === variant
  )?.defaultSettings;

  return (
    <Layout.Footer style={{ padding: "0", background: "transparent" }}>
      <Space direction="vertical" size="small" style={{ width: "100%" }}>
        <CardControls
          link={link}
          hideFavorite={variantSettings?.hideFavorite}
          hideCopyLink={variantSettings?.hideCopyLink}
          tags={tags}
          footerOptions={{
            showTags: variantSettings?.showTags,
          }}
        />
      </Space>
    </Layout.Footer>
  );
}

// Create Footer Block
const footerBlock = createBaseBlock({
  id: "footer",
  name: "Footer Block",
  description: "Displays card footer with controls and statistics",
  recipe: footerRecipe,
  variants: footerVariants,
  parser: footerParser,
  renderer: FooterBlockRenderer,
});

// Export the block for direct use
export { footerBlock };
